import axios from "axios";

// Actions

export const FETCH_GDPR_RESPONSE_REQUEST = "gdpr/FETCH_GDPR_RESPONSE_REQUEST";
export const FETCH_GDPR_RESPONSE_FAILURE = "gdpr/FETCH_GDPR_RESPONSE_FAILURE";
export const FETCH_GDPR_RESPONSE_SUCCESS = "gdpr/FETCH_GDPR_RESPONSE_SUCCESS";

// Reducer
const initialState = {
  error: null,
  loading: true
};

export default function reducer(state = initialState, action = {}) {
  switch (action?.type) {
    case FETCH_GDPR_RESPONSE_REQUEST:
      return { ...state, loading: true };
    case FETCH_GDPR_RESPONSE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        ...action.payload
      };
    case FETCH_GDPR_RESPONSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

// Action Creators
export const fetchGdprResponseRequest = () => ({
  type: FETCH_GDPR_RESPONSE_REQUEST
});

export const fetchGdprResponseFailure = error => ({
  type: FETCH_GDPR_RESPONSE_FAILURE,
  payload: error
});

export const fetchGdprResponseSuccess = data => ({
  type: FETCH_GDPR_RESPONSE_SUCCESS,
  payload: data
});

export const fetchGdprResponse = (platform = "ehost") => async (
  dispatch,
  getState
) => {
  const {
    gdpr: {
      prompt: { promptId }
    },
    intl: { locale: language },
    paths: { api }
  } = getState();
  dispatch(fetchGdprResponseRequest());
  try {
    const response = await axios.get(
      `${api}/personaluser/responses/${promptId}`,
      {
        params: {
          language,
          platform
        }
      }
    );
    dispatch(fetchGdprResponseSuccess(response.data));
  } catch (error) {
    dispatch(fetchGdprResponseFailure(error));
  }
};

/// Selectors

export const getGdprResponseError = state => state.gdpr.response.error;

export const getGdprResponseLoading = state => state.gdpr.response.loading;

export const getGdprResponseDate = state => state.gdpr.response.last_modified;
